<template>
  <StatusBadgeWithTooltip
    :status="status"
    :statusText="text"
    :tooltipText="tooltipText"
  />
</template>

<script>
// Utils
import { get } from 'lodash';

// Components
import StatusBadgeWithTooltip from 'client/components/Badges/StatusBadgeWithTooltip.vue';

const statusOptions = {
  error: 'error',
  inactive: 'inactive',
  informational: 'informational',
  success: 'success',
  warning: 'warning',
};

const mappedStatusValues = [
  { statusValue: 'NOT_ENROLLED', text: 'Not Enrolled', status: statusOptions.inactive },
  { statusValue: 'DISABLED', text: 'Disabled', status: statusOptions.inactive },
  { statusValue: 'PENDING_ACTIVATION', text: 'Pending Activation', status: statusOptions.warning },
  { statusValue: 'ENROLLMENT_EXPIRED', text: 'Enrollment Expired', status: statusOptions.error },
  { statusValue: 'IN_ENROLLMENT', text: 'In Enrollment', status: statusOptions.warning },
  { statusValue: 'PRE_ENROLLMENT', text: 'Pre-Enrollment', status: statusOptions.warning },
  { statusValue: 'ENROLLED', text: 'Enrolled', status: statusOptions.success },
];

export default {
  name: 'SystemUserMFABadgeWithTooltip',

  components: {
    StatusBadgeWithTooltip,
  },

  props: {
    getTooltipText: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    statusPath: {
      type: String,
      required: true,
    },
  },

  computed: {
    mfaEnrollmentStatusValue() {
      return get(this.item, this.statusPath, '');
    },

    status() {
      return get(this.statusObject, 'status');
    },

    statusObject() {
      return mappedStatusValues.find(
        ({ statusValue }) => statusValue === this.mfaEnrollmentStatusValue,
      );
    },

    text() {
      return get(this.statusObject, 'text');
    },

    tooltipText() {
      return this.getTooltipText(this.item);
    },
  },
};
</script>
